import { Switch } from "@progress/kendo-react-inputs"
import React from "react"
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks"
import { editCaseManDocumentRequest } from "../../../../../services/caseManService/model/caseMan/CaseManagementSlice";
import { ReduxUpdate } from "../../../../../utils/ReduxUpdateCommands";

function HistoryAndPhysicalRequest(){
    const dispatch = useAppDispatch();
    const caseMan = useAppSelector((state) => state.caseManagement.caseManagement);

    return <React.Fragment>
        <div>
            <label>History and Physical</label><br/>
            <Switch value={caseMan.documentRequest?.historyAndPhysical}
                checked={caseMan.documentRequest?.historyAndPhysical}
                onChange={(e)=>dispatch(editCaseManDocumentRequest(new ReduxUpdate('historyAndPhysical',e.target.value)))}/>
        </div>
    </React.Fragment>
}
export {HistoryAndPhysicalRequest}